export const UPDATE_STEP = "runHolder/UPDATE_STEP";

const initialState = {
  step: 0
};

function runHolderReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_STEP:
      return {
        ...state,
        step: action.data
      };
    default:
      return state;
  }
}

export function getStep(state) {
  return state.runHolder.step;
}

export function updateStep(step) {
  return { type: UPDATE_STEP, data: step };
}

export function nextStep() {
  return (dispatch, getState) => {
    return dispatch({ type: UPDATE_STEP, data: getStep(getState()) + 1 });
  };
}

export function prevStep() {
  return (dispatch, getState) => {
    return dispatch({ type: UPDATE_STEP, data: getStep(getState()) - 1 });
  };
}

export default runHolderReducer;
